<template>
    <Modal @cancel="closeModal">
        <ModalCard
            @cancel="closeModal"
            :activeValidate="
                !!(firstname && lastname && (test(telephoneMobile) || test(telephoneFixe))) &&
                !isPhoneAlreadyUsed
            "
            :headerTitle="$t(`contact.form.title.${contact === undefined ? 'new' : 'edit'}`)"
            @confirm="confirm"
        >
            <div>
                <span>
                    {{ $t('contact.form.subtitle') }}
                </span>
                <div v-if="isConnectedUser" class="input-display">
                    <div class="label-display">{{ $t('contact.form.firstname') }}</div>
                    <div class="value-display">{{ firstname }}</div>
                </div>
                <TextInput v-else class="input" v-model="firstname" :label="$t('contact.form.firstname')" />

                <div v-if="isConnectedUser" class="input-display">
                    <div class="label-display">{{ $t('contact.form.lastname') }}</div>
                    <div class="value-display">{{ lastname }}</div>
                </div>
                <TextInput v-else class="input" v-model="lastname" :label="$t('contact.form.lastname')" />
                <TextInput class="input" v-model="telephoneMobile" :label="$t('contact.form.phone.mobile')" />
                <div class="errorMsg" v-if="isMobilePhoneAlreadyUsed">{{ $t('telephone.mobile.error') }}</div>
                <TextInput class="input" v-model="telephoneFixe" :label="$t('contact.form.phone.fixe')" />
                <div class="errorMsg" v-if="isFixePhoneAlreadyUsed">{{ $t('telephone.fixe.error') }}</div>
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { DemandeInterventionContactSurSite } from '@/models/DemandeInterventionContactSurSite';
import { defineComponent, PropType } from 'vue';
import { ContactSurSiteFormState } from '@/models/ContactSurSiteForm';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import TextInput from '@/components/ui-components/TextInput.vue';
import Regex from '@/common/utils/Regex';

export default defineComponent({
    data(): ContactSurSiteFormState {
        return {
            firstname: this.contact?.firstname ?? '',
            lastname: this.contact?.lastname ?? '',
            telephoneMobile: this.contact?.telephoneMobile ?? '',
            telephoneFixe: this.contact?.telephoneFixe ?? '',
        };
    },
    props: {
        contact: {
            type: Object as PropType<ContactSurSiteFormState>,
            required: false,
        },
    },
    components: { TextInput, Modal, ModalCard },
    computed: {
        isConnectedUser(): boolean {
            return !!this.contact?.isConnectedUser;
        },
        isPhoneAlreadyUsed(): boolean{
            return this.isMobilePhoneAlreadyUsed || this.isFixePhoneAlreadyUsed;
        },
        isMobilePhoneAlreadyUsed(): boolean{
            if (!this.telephoneMobile) return false;
            const contacts = this.$store.getters.getInterventionContactSurSiteListValue;
            const mobilePhones = contacts.map((c: DemandeInterventionContactSurSite) => c.telephoneMobile);
            return mobilePhones.includes(this.telephoneMobile) && this.contact?.telephoneMobile !== this.telephoneMobile;
        },
        isFixePhoneAlreadyUsed(): boolean{
            if (!this.telephoneFixe) return false;
            const contacts = this.$store.getters.getInterventionContactSurSiteListValue;
            const landlinePhones = contacts.map((c: DemandeInterventionContactSurSite) => c.telephoneFixe);
            return landlinePhones.includes(this.telephoneFixe) && this.contact?.telephoneFixe !== this.telephoneFixe;
        },
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm', this.$data);
        },
        test(value: string) {
            const reg = Regex.telephone();
            return reg.test(value);
        },
    },
});
</script>

<style>
.input {
    margin-top: 8px;
}
.errorMsg {
    font-size: 12px;
    color: var(--red);
}
.input-display {
    margin-top: 8px;
    padding: 11px 12px;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    position: relative;
}
.label-display {
    position: absolute;
    top: -7px;
    left: 12px;
    font-size: var(--font-size-very-small);
    color: var(--medium-dark-grey);
    background-color: var(--white);
    padding: 0 2px;
}
.value-display {
    font-family: 'Roboto';
    padding-left: 8px;
    color: var(--black);
}
</style>
